// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"f71e4c9b","315":"ea3702b3","407":"8b8836ba","536":"6a3db235"}[chunkId] + ".chunk.css";
};